// src/features/records/components/GalleryView/index.js
import React from 'react';
import GalleryView from './GalleryView';
import GalleryErrorBoundary from './components/GalleryErrorBoundary';

const GalleryViewWithErrorBoundary = (props) => (
  <GalleryErrorBoundary>
    <GalleryView {...props} />
  </GalleryErrorBoundary>
);

export default GalleryViewWithErrorBoundary;